// Create our number formatter.
const numberFormat = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN'
});

const currencyFormatter = (number) => numberFormat.format(number);

export default currencyFormatter;
